import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));


export default function Home() {
  const classes = useStyles();

  return (

    <main className={classes.content}>
      <div className={classes.toolbar} />
      <Grid container spacing={1} direction="row" justify="center" alignItems="center">

        <Grid item>
          <h1> Botón de Pago </h1>
        </Grid>

      </Grid>
    </main>

  );
}
